<template>
  <!-- 管理员 作业管理 -->
  <div class="manage-job wrapper">
    <proTitle></proTitle>
    <!-- 表格 -->
    <div class="mid-bot">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号"></el-table-column>
        <el-table-column align="center" prop="name" label="作业主题名称" width="200px"></el-table-column>
        <el-table-column align="center" label="来源">
          <template slot-scope="scope">
            {{ origin[scope.row.type] }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="提交人数">
          <template slot-scope="scope">
            {{ scope.row.finish ? scope.row.finish : 0 }}/{{ scope.row.total ? scope.row.total : 0 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="total" label="完成识别人数">
          <template slot-scope="scope">
            {{ scope.row.finishCount ? scope.row.finishCount : '未识别' }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="type" label="操作" width="180px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" style="margin-left:10px" @click="getOCR(scope.row.id, scope.row)"
              :disabled="scope.row.status == 1">{{ scope.row.status == 1 ? '识别中...' : 'OCR识别' }}</el-button>
            <el-button type="text" size="small" @click="goDetail(scope.row.id, scope.row.bindId)"
              :disabled="scope.row.status != 2">查看</el-button>
            <el-button type="text" size="small" :disabled="scope.row.status != 2"
              @click="downloadOcr(scope.row.id)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage"
        :limit.sync="pages.pageSize" :pageSizes="[8, 16, 24]" @pagination="handlePageChange">
      </pagination>
    </div>
    <el-dialog title="OCR识别" :visible.sync="dialogVisible" width="40%">
      <el-form ref="form" :model="form" size="small" label-position="left">
        <el-form-item label="类型" style="display: flex; align-items: center;">
          <el-radio-group v-model="form.type" :disabled="disabled">
            <el-radio label="0">普通识别</el-radio>
            <el-radio label="1">按标题识别</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="form.type == 1">
          <el-form-item label="识别内容：" label-width="100px">
          </el-form-item>
          <div v-for="(item, index) in form.actionList" :key="index">
            <el-form-item label="行为" label-width="50px">
              <el-input v-model="item.action" :readonly="readonly"></el-input>
              <el-button type="text" v-if="index == 0" @click="addAction" :disabled="disabled"><i
                  class="el-icon-circle-plus-outline"></i></el-button>
              <el-button type="text" v-else @click="delAction(item, index)" :disabled="disabled"><i
                  class="el-icon-remove-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="标题" label-width="50px">
              <el-input v-model="item.title" :readonly="readonly"></el-input>
            </el-form-item>
          </div>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="startRecognize">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import {
  mapState
} from "vuex";
export default {
  data() {
    return {
      origin: {
        0: "作业"
      },
      form: {
        type: '0',
        actionList: [
          {
            action: '',
            title: '',
            type: 1
          },
        ],

      },
      tableData: [],
      pages: { //分页
        currentPage: 1,
        pageSize: 8,
        total: 0,
      },
      dialogVisible: false,
      ocrId: null,
      disabled: false,
      readonly: false
    };
  },
  computed: {
    ...mapState({
      userId: state => state.user.userInfo.id,
      activeName: state => state.user.currentProject.id
    })
  },
  watch: {
    '$store.state.user.currentProject.id': {
      handler(newVal, oldVal) {
        if (!newVal) return;
        this.pages.currentPage = 1;
      }
    }
  },
  methods: {
    handlePageChange() {

    },
    goDetail(ocrId, bindId) {
      this.$router.push({
        path: "/ocr_view",
        query: {
          breadNumber: 4,
          ocrId,
          bindId
        },
      });
    },
    getOCR(ocrId, item) {
      this.ocrId = ocrId;
      this.form.type = '0',
        this.actionList = [
          {
            action: '',
            title: '',
            type: 1
          },
        ]
      console.log('item:', item);
      if (item.hasOwnProperty('mode') && item.mode !== null) {
        this.getRecognizeMode(ocrId)
        this.disabled = true;
        this.readonly = true;
      } else {
        this.disabled = false;
        this.readonly = false;
      }
      this.dialogVisible = true;
    },
    addAction() {
      let obj = {
        action: '',
        title: '',
        type: 1
      }
      this.form.actionList.push(obj)
    },
    delAction(index) {
      this.form.actionList.splice(index, 1)
    },
    async ocrlist() {
      let data = {
        projectId: this.$store.state.user.currentProject.id,
        // projectId: 234,
        page: this.pages.currentPage,
        limit: this.pages.pageSize,
      }
      let resData = await this.$Api.ocr.getList(data)
      console.log('ocr列表:', resData)
      this.tableData = resData.data.records;
    },
    async startRecognize() {
      let data = {
        ocrId: this.ocrId,
        type: this.form.type,
      }
      if (this.form.type == 1) {
        let ruleJSON = JSON.stringify(this.form.actionList)
        data.rules = ruleJSON
      }
      let resData = await this.$Api.ocr.startRecognize(data)
      console.log('开始识别:', resData);
      this.dialogVisible = false;
      this.ocrlist()
    },
    async getRecognizeMode(id) {
      let data = {
        id
      }
      let resData = await this.$Api.ocr.getRecognizeMode(data)
      console.log('获取识别记录的识别模式:', resData);
      this.form.type = resData.data[0].type.toString();
      if (resData.data[0].type == 1) {
        this.form.actionList = JSON.parse(resData.data[0].rule)
      }
    },
    downloadOcr(id) {
      window.location.href = axios.defaults.baseURL + "/quest/ocr/download/export?id=" + id
    }
  },
  mounted() {
    this.ocrlist()
  }
};
</script>

<style lang="less" scoped>
@import "../manage/less/table.less";

.manage-job {
  padding: 20px 25px;
  box-sizing: border-box;
}

.mid-bot {
  margin-top: 15px;
}

.myitem {}

/deep/ .el-dialog__body {
  padding-left: 50px;
}

/deep/ .el-dialog__body {
  justify-content: flex-start;
}

/deep/ .el-input__inner {
  width: 400px;
}

/deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}

i {
  margin-left: 10px;
  font-size: 20px;
}
</style>